function fallbackCopyTextToClipboard(text: string) {
	return new Promise((resolve, reject) => {
		let textArea = document.createElement("textarea")
		textArea.value = text

		// Avoid scrolling to bottom
		textArea.style.top = "0"
		textArea.style.left = "0"
		textArea.style.position = "fixed"

		document.body.appendChild(textArea)
		try {
			textArea.focus()
			textArea.select()
			let successful = document.execCommand("copy")
			if (!successful) {
				reject(new Error("Failed to copy text."))
			}
		} finally {
			document.body.removeChild(textArea)
		}
	})
}

export default function copyTextToClipboard(text: string) {
	if (navigator.clipboard == null) {
		return fallbackCopyTextToClipboard(text)
	}
	return navigator.clipboard.writeText(text)
}
